var mentions_default = {
  "mention": "loelJ",
  "mentionViewer": "jrknM",
  "cursorDefault": "I5U3R",
  "cursorPointer": "ww7eN"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
